import {BaseMyopMessage, Ref} from "./BaseMessage.ts";

export class SetInnerHtml extends BaseMyopMessage<string> {

    messageType = 'SetInnerHtml';

    constructor(public ref: Ref, innerHtml: string) {
        super();
        this.content = innerHtml
    }
}